import { Column, Bar } from "@ant-design/plots";

import { useGraphTheme } from "../../../../hooks/useGraphTheme";

const QueryAnalyticsGenericBarGraph = ({
  dataPoints = [],
  xAxisFieldName = "date",
  yAxisFieldName = "value",
  showHorizontalBarGraph = false
}) => {
  const graphTheme = useGraphTheme();

  const config = {
    data: dataPoints || [],
    xField: xAxisFieldName,
    yField: yAxisFieldName,
    ...graphTheme
  };
  if (showHorizontalBarGraph) {
    // Horizontal column chart config
    return <Bar {...config} />;
  } else {
    // Vertical column chart config
    return <Column {...config} xField={xAxisFieldName} yField="value" />;
  }
};

export default QueryAnalyticsGenericBarGraph;
